import { z } from 'zod';

/**
 * What a house must look like before it is saved. Mirrors the backend's
 * `houses.validation.ts` — the server is the authority, and the one that knows
 * whether the name is already taken.
 */
export const houseSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Give the house a name')
    .max(40, 'Keep the name under 40 characters'),
  description: z.string().trim().max(200, 'Keep it under 200 characters'),
});

export type HouseFormValues = z.input<typeof houseSchema>;

export const EMPTY_HOUSE: HouseFormValues = { name: '', description: '' };

/** The most students one assignment may move — mirrors the server's `MAX_ASSIGN_STUDENTS`. */
export const MAX_ASSIGN_STUDENTS = 500;
